import PropTypes from 'prop-types';
import Span from '../../Span';
import styles from './styles.module.scss';
import Text from '@/components/component-library/Text';
import CaretIcon from '@/components/component-library/Icon/types/Caret';
import { classes } from '@/helpers/styling';

const ButtonTextWithCaret = ({
  children,
  className,
  ...props
}) => (
  <Text className={ classes(className, styles.textWithCaretButton) } { ...props }>
    { children }
    { ' ' }
    <Span
      className={ styles.caretIcon }
    >
      <CaretIcon />
    </Span>
  </Text>
);

ButtonTextWithCaret.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired,
  className: PropTypes.string
};

ButtonTextWithCaret.defaultProps = { className: '' };

export default ButtonTextWithCaret;